import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { hooks } from '../api/http';

/* Toast (dole desno, da ne prekriva polja forme; uspeh 3 s, ostalo 5 s) + potvrde (Da/Ne). Tipovi: info, success, warn, error. */

const AlertCtx = createContext(null);

export function AlertProvider({ children }) {
    const toast = useRef(null);

    /* kao stari AlertService: najviše 5 poruka odjednom, najstarija se uklanja */
    const visible = useRef([]);
    const show = useCallback((severity, summary, detail) => {
        if (!toast.current) return;
        if (visible.current.length >= 5) toast.current.remove(visible.current.shift());
        const msg = { id: `${Date.now()}-${Math.random()}`, severity, summary, detail, life: severity === 'success' ? 3000 : 5000 };
        visible.current.push(msg);
        toast.current.show(msg);
    }, []);

    const confirm = useCallback(
        (header, message, { icon = 'pi pi-question-circle', severity } = {}) =>
            new Promise((resolve) => {
                confirmDialog({
                    header, message, icon,
                    acceptLabel: 'Da', rejectLabel: 'Ne',
                    acceptClassName: severity === 'danger' ? 'p-button-danger' : undefined,
                    accept: () => resolve(true),
                    reject: () => resolve(false),
                    onHide: () => resolve(false),
                });
            }),
        []
    );

    useEffect(() => {
        hooks.toast = show;
        return () => { hooks.toast = null; };
    }, [show]);

    const api = useMemo(() => ({
        success: (detail, summary = 'Uspeh') => show('success', summary, detail),
        error: (detail, summary = 'Greška') => show('error', summary, detail),
        info: (detail, summary) => show('info', summary || 'Info', detail),
        warn: (detail, summary) => show('warn', summary || 'Upozorenje', detail),
        confirm,
    }), [show, confirm]);

    return (
        <AlertCtx.Provider value={api}>
            <Toast ref={toast} position="bottom-right"
                onRemove={(m) => { visible.current = visible.current.filter((x) => x.id !== m.id); }} />
            <ConfirmDialog />
            {children}
        </AlertCtx.Provider>
    );
}

export const useAlerts = () => useContext(AlertCtx);
